<template>
    <div>
      <el-form-item label="答案音频">
        <el-switch v-model="config.answerAudio"></el-switch>
      </el-form-item>
      <el-form-item label="答题解析">
        <el-checkbox border v-model="config.showReviewsContent" label="内容说明"></el-checkbox>
        <el-checkbox border v-model="config.showReviewsGrammar" label="关联语法"></el-checkbox>
      </el-form-item>
      <el-form-item label="AI超解析">
        <el-radio-group v-model="config.aiChao">
          <el-radio-button :label="0">没有小超</el-radio-button>
          <el-radio-button :label="1">有小超没有解析</el-radio-button>
          <el-radio-button :label="2">有小超有解析</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="翻译按钮">
        <el-checkbox border v-model="config.translatable.subject" label="题干可翻译" :false-label="0" :true-label="1"></el-checkbox>
        <el-checkbox border v-model="config.translatable.answers" label="正确答案可翻译" :false-label="0" :true-label="1"></el-checkbox>
      </el-form-item>
    </div>
</template>

<script>
export default {
  name: 'zct',
  data () {
    return {
      config: {
        answerAudio: true,
        showReviewsContent: false,
        showReviewsGrammar: false,
        aiChao: 2,
        translatable: {},
      }
    }
  }
}
</script>